




































































































































































































































































































































































import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import { debounce, isObject } from 'lodash';

import { getPlansData } from '@/web/utils/plans';
import { mapGetters } from 'vuex';
import auth from '@/core/api/modules/auth';
import { style } from '@/web/utils/stripe';
import { trackPurchase, register } from '@/web/services/analytics';
import { errorToMessage, scrollToFirstFormError } from '@/core/utils/errors';
import { loadDeadlineFunnelScript } from '@/web/utils/deadlinefunnel';
import timezones from '@/web/utils/timezones.ts';
import { getConfig } from '@/web/utils/configuration';
import StudentLogin from '@/web/components/signup/StudentLogin.vue';
import SelectPlanModal from '@/web/components/signup/SelectPlanModal.vue';
import { sanitize } from '@/core/utils/utils';
import { getTrackingParams } from '@/web/utils/tracking';

export default Vue.extend({
  components: { ValidationObserver },
  data() {
    return {
      subscriptionType: undefined,
      selectedPlanKey: undefined,
      allPlansInclude: [
        'SIGNUP.TEXT.LIVE_STREAMING',
        'SIGNUP.TEXT.SET_YOUR_PRICING',
        'SIGNUP.TEXT.OFFER_COACHING',
        'SIGNUP.TEXT.NO_REV_SHARE',
        'SIGNUP.TEXT.SELL_COURSES',
        'SIGNUP.TEXT.INSTANT_PAYOUTS',
      ],
      teacherForm: {
        yoga_alliance_membership_id: '',
        studio_name: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
      },
      usingCoupon: false,
      freeTrial: false,
      forceCoupon: false,
      coupon: null,
      couponError: null,
      inProgress: false,
      stripeCompleted: false,
      stripeError: false,
      emailInfo: null,
      URLInfo: null,
      timezone: null,
      timezones,
      campaigns: {
        yogaalliance: {
          logo: '/assets/images/yoga-alliance.png',
        },
        lululemon: {
          logo: '/assets/images/lululemon.png',
          brandColor: '#C8102E',
        },
      },
      isUsedEmail: false,
    };
  },
  props: {
    campaign: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('user', [
      'userId',
      'studentId',
      'teacher',
      'userPlans',
      'couponDuration',
      'isLoggedIn',
    ]),
    ...mapGetters({
      affiliateCode: 'globals/affiliateCode',
      affiliateCoupon: 'affiliates/affiliateCoupon',
    }),
    getStudioName() {
      const studioName = this.teacherForm?.studio_name;
      if (!studioName || studioName === '') {
        return `${this.teacherForm.first_name} ${this.teacherForm.last_name}`;
      }
      return this.teacherForm.studio_name;
    },
    displayCouponField() {
      if (!this.freeTrial) return true;
      return this.forceCoupon;
    },
    plansData() {
      if (!this.subscriptionType) return [];
      return [...(this.userPlans || [])]
        .filter(plan => !(plan.hide_for_affiliates && this.affiliateCode))
        .sort((planA, planB) => planB.tier - planA.tier)
        .map(plan =>
          getPlansData(
            plan,
            this.subscriptionType,
            this.selectedPlanId,
            this.freeTrial,
            7,
            this.couponDuration
          )
        );
    },
    selectedPlanId() {
      if (!this.selectedPlanKey) return undefined;
      return this.userPlans?.find(plan => {
        return (
          this.selectedPlanKey == plan.plan_name.toLowerCase() ||
          this.selectedPlanKey === (plan.display_name ?? '').toLowerCase()
        );
      })?.id;
    },
    selectedPlan() {
      return this.plansData?.find(plan => plan.id === this.selectedPlanId);
    },
    isDiscounted() {
      return this.selectedPlan?.discounted;
    },
    isDiscountedForever() {
      return this.couponDuration?.duration === 'forever';
    },
    isDiscountedOnce() {
      if (this.isDiscountedMonths && this.discountedMonthsNum) return true;

      return this.couponDuration?.duration === 'once';
    },
    isDiscountedMonths() {
      return this.couponDuration?.duration === 'repeating';
    },
    discountedMonthsNum(): number {
      return this.couponDuration?.duration_in_months || 0;
    },
    discountedText() {
      if (!this.isDiscounted) return '';
      if (this.isDiscountedForever) return '';
      let months = 1;
      if (this.isDiscountedMonths) {
        months = this.discountedMonthsNum as number;
      }
      const discountedPrice = this.selectedPlan.amount;
      const standardPrice = this.selectedPlan.standard;
      const paymentInterval =
        this.subscriptionType === 'monthly' ? 'mo' : 'year';
      if (this.subscriptionType === 'monthly') {
        if (discountedPrice === 0) {
          return this.$tc('SIGNUP.TEXT.MONTHLY_TOTAL_CHECKOUT_FREE', months, {
            discountedPrice,
            months,
            paymentInterval,
            standardPrice,
          });
        }
        return this.$tc('SIGNUP.TEXT.MONTHLY_TOTAL_CHECKOUT', months, {
          discountedPrice,
          months,
          paymentInterval,
          standardPrice,
        });
      } else {
        const years = Math.ceil(months / 12);
        if (discountedPrice === 0) {
          return this.$tc('SIGNUP.TEXT.ANNUAL_TOTAL_CHECKOUT_FREE', years, {
            discountedPrice,
            years,
            paymentInterval,
            standardPrice,
          });
        }
        return this.$tc('SIGNUP.TEXT.ANNUAL_TOTAL_CHECKOUT', years, {
          discountedPrice,
          years,
          paymentInterval,
          standardPrice,
        });
      }
    },
    invalidPlan() {
      return this.userPlans?.length && !this.selectedPlan;
    },
    campaignData() {
      return this.campaigns[this.campaign];
    },
    config() {
      return getConfig();
    },
    applicationName() {
      return this.config.applicationName;
    },
    isNamastreamDomain() {
      return window.location.host.toLowerCase().indexOf('namastream') !== -1;
    },
    affiliateDiscount() {
      const coupon = this.affiliateCoupon;
      if (!coupon) return null;

      let duration = '';
      if (coupon.duration === 'forever') {
        duration = ` ${this.$t(
          'SIGNUP.TEXT.AFFILIATE_COUPON_DURATION_FOREVER'
        )}`;
      } else if (coupon.duration === 'repeating') {
        duration = ` ${this.$tc(
          'SIGNUP.TEXT.AFFILIATE_COUPON_DURATION_REPEATING_VARIANT',
          coupon.duration_in_months,
          { duration: coupon.duration_in_months }
        )}`;
      }

      if (coupon.amount_off) return `$${coupon.amount_off}${duration}`;
      if (coupon.percent_off) return `${coupon.percent_off}%${duration}`;

      return null;
    },
    getAffiliateDiscountedPrice() {
      const coupon = this.affiliateCoupon;
      if (!coupon) return null;
      const plan = this.selectedPlan;

      let discountedPrice = plan.amount;
      if (coupon.amount_off) {
        discountedPrice = Math.max(plan.amount - coupon.amount_off, 0);
      }
      if (coupon.percent_off) {
        discountedPrice =
          Math.round(100 * plan.amount * ((100 - coupon.percent_off) / 100.0)) /
          100;
      }

      return discountedPrice;
    },
    getSelectedPlanAffiliateDiscountCheckoutSummaryText() {
      const coupon = this.affiliateCoupon;
      if (!coupon) return null;
      const plan = this.selectedPlan;

      const discountedPrice = this.getAffiliateDiscountedPrice;

      if (coupon.duration === 'once') {
        return this.$t('SIGNUP.TEXT.AFFILIATE_COUPON_INITIAL_PAYMENT', {
          discountedPrice,
          originalAmount: plan.fullAmountText,
        });
      } else if (coupon.duration === 'forever') {
        // forever coupons are applied for all plans forever and don't need
        // any special text on how long the discount is valid
        return null;
      } else if (coupon.duration === 'repeating') {
        return this.$tc(
          'SIGNUP.TEXT.AFFILIATE_COUPON_DURATION_REPEATING_THEN_ORIGINAL_AMOUNT_VARIANT',
          coupon.duration_in_months,
          {
            duration: coupon.duration_in_months,
            discountedPrice,
            originalAmount: plan.fullAmountText,
          }
        );
      }

      return null;
    },
    getCheckoutFullAmountText() {
      if (this.getAffiliateDiscountedPrice) {
        return this.$t(this.selectedPlan.amountKey, {
          amount: this.getAffiliateDiscountedPrice,
        });
      }

      return this.selectedPlan.fullAmountText;
    },
  },
  methods: {
    sanitize,
    openPlanModal() {
      this.$modal.show(
        SelectPlanModal,
        {
          initalSelectedPlanId: this.selectedPlanId,
          initalSubscriptionType: this.subscriptionType,
          freeTrial: this.freeTrial,
        },
        {},
        {
          'select-plan': this.onUrlChange,
        }
      );
    },
    onUrlChange({ planId, subscriptionType }) {
      const plan = this.plansData.find(plan => plan.id === planId);

      if (subscriptionType !== this.subscriptionType) {
        this.$trackOnPage('teacher switched signup type', { subscriptionType });
      }
      if (planId !== this.selectedPlanId) {
        this.$trackOnPage('teacher switched signup plan', {
          plan_id: planId,
          plan_name: plan.name,
        });
      }

      this.$router.push({
        name: 'Join',
        query: {
          ...this.$route.query,
          plan: plan.key,
          interval: subscriptionType,
        },
      });
    },
    openLoginModal() {
      this.$modal.show(StudentLogin, {});
    },
    setSubscriptionType(type) {
      this.subscriptionType = type;
      this.$trackOnPage('teacher switched signup type', { type });
    },
    removeCoupon() {
      this.$store.dispatch('user/clearCoupon');
    },
    async validateStudioName() {
      // can't validate studio url without auth headers of an existing account... how to do this?
      console.log('validation needed');
    },
    async applyCoupon() {
      try {
        const coupon = this.coupon;
        const campaign = this.campaign;
        await this.$store.dispatch('user/applyCoupon', { coupon, campaign });
        this.couponError = null;
        this.usingCoupon = true;
      } catch (error) {
        this.couponError = error.response.data?.message;
        this.usingCoupon = false;
      }
    },
    stripeChangeCallback(event) {
      if (event.complete) {
        this.stripeCompleted = true;
        this.stripeError = false;
      } else if (event.error) {
        this.stripeCompleted = false;
        this.stripeError = event.error.message;
      }
    },
    initStripe() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC);
      const elements = this.stripe.elements();
      this.card = elements.create('card', {
        style,
        hidePostalCode: true,
      });
      const interval = setInterval(
        () => {
          if (this.$refs['card-element']) {
            this.card.mount(this.$refs['card-element']);
            this.card.addEventListener('change', this.stripeChangeCallback);
            clearInterval(interval);
          }
        },
        50,
        100
      );
    },

    async signup() {
      this.$refs.form.validate();
      const invalid = this.$refs.form?.flags?.invalid;
      if (invalid) {
        setTimeout(() => {
          scrollToFirstFormError();
        });
      }

      if (
        !this.stripeCompleted ||
        !this.timezone ||
        invalid ||
        this.inProgress
      ) {
        return;
      }

      const reCaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
      let reCaptchaToken;
      try {
        reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
          action: 'teachersetupintent',
        });
      } catch (error) {
        this.inProgress = false;
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t('GENERAL.ERROR.RECAPTCHA_FAILED'),
        });
      }

      this.inProgress = true;
      const data = {
        ...this.teacherForm,
        ...getTrackingParams(),
        studio_name: this.getStudioName,
        coupon: this.coupon || this.affiliateCoupon?.discount_coupon_code,
        campaign: this.campaign,
        plan_id: this.selectedPlanId,
        subscription_type: this.subscriptionType,
        password1: this.teacherForm.password,
        timezone: this.timezone.value,
        free_trial: this.freeTrial,
        token: reCaptchaToken,
      };

      if (this.campaign !== 'yogaalliance')
        delete data.yoga_alliance_membership_id;

      try {
        const setupIntent = await auth.getSetupIntent(data);
        data.stripe_customer_id = setupIntent.stripe_customer_id;
        data.setup_intent_id = setupIntent.setup_intent.id;

        const confirmCard = await this.stripe.confirmCardSetup(
          setupIntent.setup_intent.client_secret,
          { payment_method: { card: this.card } }
        );

        data.default_payment_method = confirmCard.setupIntent.payment_method;

        data.affiliate_ref = this.affiliateCode;

        reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
          action: 'teachersignup',
        });
        data.token = reCaptchaToken;

        if (this.isLoggedIn) await auth.promoteStudentToTeacher(data);
        else await auth.registerTeacher(data);

        const selectedPlan = this.userPlans.find(
          plan => plan.id == this.selectedPlanId
        );

        const planAmount = selectedPlan[`${this.subscriptionType}_amount`];

        if (!this.isLoggedIn) await this.$store.dispatch('user/login', data);

        await this.$store.dispatch('user/loadUserInfo');

        const registerData = {
          first_name: this.teacher?.first_name,
          last_name: this.teacher?.last_name,
          email: this.teacher?.email,
          user_id: this.userId,
          student_id: this.studentId,
          studio_url: this.teacher?.studio_url,
          studio_name: this.teacher?.studio_name,
        };

        const traitsData = {
          coupon: this.coupon || this.affiliateCoupon?.discount_coupon_code,
          affiliate_ref: this.affiliateCoupon?.ref,
          campaign: this.campaign,
          plan_id: this.selectedPlanId,
          plan_name: this.selectedPlan.plan_name,
          plan_amount: planAmount,
          subscription_type: this.subscriptionType,
          studio_name: this.teacher?.studio_name,
        };

        register(this.userId, registerData);
        this.$trackOnPage('teacher signed up', {
          ...registerData,
          ...traitsData,
        });
        trackPurchase(traitsData);
        const query = {};
        if (this.freeTrial) query.trial = true;

        this.$router.push({
          name: 'thank-you',
          query,
        });
      } catch (error) {
        console.error(error);
        const errorMessage = errorToMessage(error.response);
        if (isObject(errorMessage)) {
          this.$refs.form.setErrors(errorMessage);
          scrollToFirstFormError();
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: errorMessage || error,
            duration: -1, // stay ON
          });
        }
        this.inProgress = false;
      }
    },
    loadScripts() {
      loadDeadlineFunnelScript();
    },
    setLocalTimeZone() {
      try {
        const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const timezone = this.timezones.find(
          ({ value }) => value === localTimeZone
        );
        if (timezone) this.timezone = timezone;
      } catch (error) {
        console.error(error);
      }
    },
    setBrandColor(color) {
      const html = document.querySelector('html');
      html.style.setProperty('--brand-color', color);
    },
    async redirectIfTeacher() {
      await this.$store.state.user.userInfoPromise;
      if (this.teacher) {
        this.$router.replace({ name: 'settings-adjust-plan' });
      }
    },
  },
  watch: {
    'teacherForm.email': debounce(async function () {
      if (this.$refs.form.fields?.email.valid) {
        try {
          await auth.verifyEmail(this.teacherForm.email);
          this.emailInfo = null;
        } catch (error) {
          this.emailInfo = this.$t('GENERAL.ERROR.ARE_YOU_SURE_THIS_EMAIL');
        }
      } else {
        this.emailInfo = null;
      }

      if (this.$refs.form.fields?.email.valid) {
        try {
          await auth.verifyNewEmail(this.teacherForm.email);
          this.isUsedEmail = false;
        } catch (error) {
          this.isUsedEmail = true;
        }
      } else {
        this.isUsedEmail = false;
      }
    }, 400),
    affiliateCoupon: {
      handler(affiliateCoupon) {
        if (affiliateCoupon && affiliateCoupon.duration === 'forever') {
          this.coupon = this.affiliateCoupon.discount_coupon_code;
          this.applyCoupon();
        }
      },
      immediate: true,
    },
    '$route.query': {
      handler() {
        const { plan, interval } = this.$route.query;
        if (plan && interval) {
          this.selectedPlanKey = plan;
          this.subscriptionType = interval;
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.redirectIfTeacher();
    this.freeTrial = 'free-trial' in this.$route.query;
    this.forceCoupon = 'coupon' in this.$route.query;
    if (this.isNamastreamDomain && process.env.NODE_ENV === 'production') {
      window.location.hostname = 'app.heymarvelous.com';
    }
    this.campaign = this.campaign || getConfig().signupCampaign;
    this.initStripe();
    this.loadScripts();
    this.removeCoupon();
    await this.$store.dispatch('user/getPlans', this.campaign);
    const defaultPlan =
      this.userPlans.find(plan => plan.is_default) || this.userPlans[0];

    if (
      !this.$route.query.plan ||
      !['yearly', 'monthly'].includes(this.$route.query.interval)
    ) {
      const interval = this.$route.query.interval || 'yearly';
      const plan = (
        this.$route.query.plan || defaultPlan.plan_name
      )?.toLowerCase();
      this.$router.replace({
        name: 'Join',
        query: {
          ...this.$route.query,
          plan,
          interval,
        },
      });
    }

    this.setLocalTimeZone();
    if (this.campaignData?.brandColor) {
      this.setBrandColor(this.campaignData.brandColor);
    }
  },
  destroyed() {
    this.removeCoupon();
    this.setBrandColor(null);
  },
});
